import React from 'react';
import '../template-file-css/document-file-template.css';


export const PD_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='PD_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <strong>Consumer Information</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Discharge:</span>
                            <input type='date' id="txtDischargeDate" name="txtDischargeDate" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapist's Name:</span>
                            <input type='text' id="txtTherapist" name="txtTherapist" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                <h2>Principal Diagnosis</h2>
                <h5>(Provide principal DSM-V/ICD-10 behavioral and medical diagnoses)</h5> 
                </p>

                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Code</span>
                        </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Description</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_1" name="txtCode_1" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_1" name="txtDesc_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_2" name="txtCode_2" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_2" name="txtDesc_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_3" name="txtCode_3" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_3" name="txtDesc_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_4" name="txtCode_4" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_4" name="txtDesc_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_5" name="txtCode_5" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_5" name="txtDesc_5" className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><b>I. Initial Diagnosis</b></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS I Code #:</span>
                            <input type='text' id="txtInitialAXISI" name="txtInitialAXISI" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS II Code #:</span>
                            <input type='text' id="txtInitialAXISII" name="txtInitialAXISII" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS III Code #:</span>
                            <input type='text' id="txtInitialAXISIII" name="txtInitialAXISIII" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS IV Code #:</span>
                            <input type='text' id="txtInitialAXISIV" name="txtInitialAXISIV" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS V GAF:</span>
                            <input type='text' id="txtInitialAXISV" name="txtInitialAXISV" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        II. Discharge Diagnosis</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS I Code #:</span>
                            <input type='text' id="txtDischargeAXISI" name="txtDischargeAXISI" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS II Code #:</span>
                            <input type='text' id="txtDischargeAXISII" name="txtDischargeAXISII" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS III Code #:</span>
                            <input type='text' id="txtDischargeAXISIII" name="txtDischargeAXISIII" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS IV Code #:</span>
                            <input type='text' id="txtDischargeAXISIV" name="txtDischargeAXISIV" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AXIS V GAF:</span>
                            <input type='text' id="txtDischargeAXISV" name="txtDischargeAXISV" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><b>III. Services and Termination Status</b></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Opening Date:</span>
                            <input type='date' id="dtOpeningDate" name="dtOpeningDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Termination Date:</span>
                            <input type='date' id="dtTerminationDate" name="dtTerminationDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total Number of Sessions:</span>
                            <input type='text' id="txtNumberOfSessions" name="txtNumberOfSessions" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Discharge Criteria:</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer was to meet all the goals of his treatment plan which included:</span>
                    <textarea typeof='text' id="TextBox4" name="TextBox4" className='add-only' ></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Living Situation at the Time of Discharge:</span>
                    <textarea id="txtLivingSituationDischargeTime" name="txtLivingSituationDischargeTime" className='add-only' ></textarea>
                </p>
                <table >
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Which of the following services were used with the client during the program?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_1' name='chkServicesUsed_1' className='add-only' value="CSI" /> CSI
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_2' name='chkServicesUsed_2' className='add-only' value="Family" /> Family
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_3' name='chkServicesUsed_3' className='add-only' value="Family Team Conferencing" /> Family Team Conferencing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_4' name='chkServicesUsed_4' className='add-only' value="Group" /> Group
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_5' name='chkServicesUsed_5' className='add-only' value="Individual" /> Individual
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_6' name='chkServicesUsed_6' className='add-only' value="Other" /> Other
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_7' name='chkServicesUsed_7' className='add-only' value="Psych" /> Psych
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_8' name='chkServicesUsed_8' className='add-only' value="Testing" /> Testing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_9' name='chkServicesUsed_9' className='add-only' value="Psychiatric" /> Psychiatric
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id='chkServicesUsed_10' name='chkServicesUsed_10' className='add-only' value="Transition Planning" /> Transition Planning
                        </td></tr>
                </table>
                <p className='w-750'><b>IV. Overall Status at Termination</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Overall status at termination:</span>
                    <select id="ddlStatusAtTermination" name="ddlStatusAtTermination" className='add-only'>
                        <option value="N/A">N/A</option>
                        <option value="Marked Improvement">Marked Improvement</option>
                        <option value="Moderate Improvement">Moderate Improvement</option>
                        <option value="No Change">No Change</option>
                        <option value="Regressed">Regressed</option>
                    </select>
                </p>
                <p className='w-750'><b>V. Reason(s) for Termination</b> </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_1' name='chkReasonsForTermination_1' className='add-only' value="Discharged as planned" /> Discharged as planned
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_2' name='chkReasonsForTermination_2' className='add-only' value="Have missed excessive appointments" /> Have missed excessive appointments
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_3' name='chkReasonsForTermination_3' className='add-only' value="Insufficient progress in therapy" /> Insufficient progress in therapy
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_4' name='chkReasonsForTermination_4' className='add-only' value="No longer making appointments" /> No longer making appointments
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_5' name='chkReasonsForTermination_5' className='add-only' value="Referred for other services" /> Referred for other services
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_6' name='chkReasonsForTermination_6' className='add-only' value="Terminated against therapist's advice" /> Teminated against therapist's advice
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_7' name='chkReasonsForTermination_7' className='add-only' value="Therapist is leaving the clinic or area" /> Therapist is leaving the clinic or area
                        </td>  
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <input type="checkbox" id='chkReasonsForTermination_8' name='chkReasonsForTermination_8' className='add-only' value="Other" /> Other:
                            <input type='text' id='txtReasonsForTermination_8' name='txtReasonsForTermination_8'  className='add-only w-200' /> 
                        </td>

                    </tr>
                </table>
                <p className='w-750'><b>VI. Presenting Problem and Assessment</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting problem and assessment:</span>
                    <span className='small'>Subjective evaluation: Summarize specific symptomology, onset, duration
                        and frequency of Sx's. Include consumer's assessment of presenting problems and
                        reason(s) for seeking services. Also include factors such as family or environmental
                        factors affecting functioning.</span>
                    <textarea id="txtProblemAssessment" name="txtProblemAssessment" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer's Strengths, Needs, Abilities and Preferences (SNAPS)</span>
                    <textarea id="txtSNAPS" name="txtSNAPS" className='add-only' ></textarea></p>
                <p className='w-750'><b>VII. Clinical Course</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'>Clinical Course</span>
                    <span className='small'>Impact of services upon each problem identified in the TREATMENT
                        PLAN. What the client and therapist did to become healthy and was there any improvement
                        in the consumer's condition in regards to specific problem areas.</span>
                    <textarea id="txtClinicalCourse" name="txtClinicalCourse" className='add-only' ></textarea></p>
                <p className='w-750'><b>VIII. Medical/Psychiatric Status</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical/Psychiatric Status</span>
                    <span className='small'>Was the consumer seen by the psychiatrist for either a psychiatric
                        evaluation or for medications? Discharge meds, dosages and instructions.</span>
                    <textarea id="txtMedicalStatus" name="txtMedicalStatus" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Medication and Dosage</span>
                    <textarea id="txtMedsDosage" name="txtMedsDosage" className='add-only' ></textarea></p>
                <p className='w-750'><b>IX. Post-Termination Plan</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Post-Termination Plan</span>
                    <span className='small'>Include referrals, appointments, dispositions, and consumer's reaction.</span>
                    <textarea id="txtPostTerminationPlans" name="txtPostTerminationPlans" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>Goals not met from the treatment plan</span>
                    <span className='small'>Provide details of goals not met.</span>
                    <textarea id="txtGoalsNotMet" name="txtGoalsNotMet" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <b>X. Consumer's Statement Regarding Satisfaction of Treatment Rendered</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer's statement regarding satisfaction of treatment rendered</span>
                    <span className='small'>What did the consumer say about their satisfaction with the course
                        of treatment?</span>
                    <textarea id="txtConsumerSatisfaction" name="txtConsumerSatisfaction" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>Therapist's recommendations #1</span>
                    <textarea id="txtRecommendations1" name="txtRecommendations1" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>Therapist's recommendations #2</span>
                    <textarea id="txtRecommendations2" name="txtRecommendations2" className='add-only' ></textarea></p>
                <p className='w-750'>
                    <span className='eleHeader'>Therapist's recommendations #3</span>
                    <textarea id="txtRecommendations3" name="txtRecommendations3" className='add-only' ></textarea></p>

                    <p className='w-750'><b>XI. Outcome Measures (CAFAS)</b></p>
                <p className='w-750'>
                    <textarea id="txtOutcomeMeasures" name="txtOutcomeMeasures" className='add-only' ></textarea>
                    
                </p>
                {/* <table>
                    <tr>
                        <td className='w-375'>Pre CAFAS Score (at admission)</td>
                        <td className='w-375'>Post CAFAS Score (at discharge)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School:</span>
                            <input type='text' id="txtOMPreSchool" name="txtOMPreSchool" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>School:</span>
                            <input type='text' id="txtOMPostSchool" name="txtOMPostSchool" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Home:</span>
                            <input type='text' id="txtOMPreHome" name="txtOMPreHome" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Home:</span>
                            <input type='text' id="txtOMPostHome" name="txtOMPostHome" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Community:</span>
                            <input type='text' id="txtOMPreCommunity" name="txtOMPreCommunity" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Comunity:</span>
                            <input type='text' id="txtOMPostCommunity" name="txtOMPostCommunity" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Behavior Towards Others:</span>
                            <input type='text' id="txtOMPreBehavior" name="txtOMPreBehavior" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Behavior Towards Others:</span>
                            <input type='text' id="txtOMPostBehavior" name="txtOMPostBehavior" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Mood/Emotions:</span>
                            <input type='text' id="txtOMPreMood" name="txtOMPreMood" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Mood/Emotions:</span>
                            <input type='text' id="txtOMPostMood" name="txtOMPostMood" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Self-Harm:</span>
                            <input type='text' id="txtOMPreSelf" name="txtOMPreSelf" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Self-Harm:</span>
                            <input type='text' id="txtOMPostSelf" name="txtOMPostSelf" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Use:</span>
                            <input type='text' id="txtOMPreSubstance" name="txtOMPreSubstance" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Use:</span>
                            <input type='text' id="txtOMPostSubstance" name="txtOMPostSubstance" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Thinking:</span>
                            <input type='text' id="txtOMPreThinking" name="txtOMPreThinking" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Thinking:</span>
                            <input type='text' id="txtOMPostThinking" name="txtOMPostThinking" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>TOTAL:</span>
                            <input type='text' id="txtOMPreTotal" name="txtOMPreTotal" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>TOTAL:</span>
                            <input type='text' id="txtOMPostTotal" name="txtOMPostTotal" className='add-only' />
                        </td>
                    </tr>
                </table> */}
                <p className='w-750'>
                    <span className='eleHeader'>XI. Summary of CAFAS scores pre and post:</span>
                    <textarea id="txtCAFASscores" name="txtCAFASscores" className='add-only' ></textarea></p>

                <p className='w-750'><b>XII. Aftercare Plan (Six month follow-up).</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>XII. Aftercare Plan at six months post treatment/follow-up.:</span>
                    <textarea id="txtAtercare" name="txtAtercare" className='add-only' ></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Location of Discharge:</span>
                            <input type='text' id="txtLocationOfDischarge" name="txtLocationOfDischarge" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Anticipated Step Down Service:</span>
                            <input type='text' id="txtAnticipatdStepDownService" name="txtAnticipatdStepDownService" className='add-only' />
                        </td>
                    </tr>
                </table>


            </div>
        </form >
    )
}